import { WIDGET_CONFIG } from '../config'

interface AskAIRowProps {
  query?: string
  onAskAI?: (query: string) => void
}

export function AskAIRow({ query, onAskAI }: AskAIRowProps) {
  function handleClick() {
    onAskAI?.(query ?? '')
  }

  return (
    <div class="spotlight-ask-ai-row" onClick={handleClick} onKeyDown={(e) => e.key === 'Enter' && handleClick()} role="button" tabIndex={0} aria-label="Ask AI">
      <span class="spotlight-ask-ai-icon">{WIDGET_CONFIG.copy.askAiIcon}</span>
      <div class="spotlight-ask-ai-text">
        <div class="spotlight-ask-ai-title">
          {query ? `${WIDGET_CONFIG.copy.askAiPrefix}${query}"` : WIDGET_CONFIG.copy.askAiDefault}
        </div>
        <div class="spotlight-ask-ai-subtitle">
          {WIDGET_CONFIG.copy.askAiSubtitle}
        </div>
      </div>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: var(--spotlight-text-muted)">
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </div>
  )
}
